import React from 'react';
import { Typography, Box, Grid } from '@mui/material';
import { styled } from '@mui/system';
const StyledContainer = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	padding: '2rem',
	textAlign: 'center',
	backgroundColor: '#f5f5f5',
}));

const StyledBadge = styled('img')({
	width: '200px',
	height: '200px',
	margin: '20px 0',
});

const StyledButton = styled(Box)(({ theme }) => ({
	backgroundColor: '#e00',
	color: '#fff',
	padding: theme.spacing(1),
	margin: theme.spacing(1),
	borderRadius: '5px',
	cursor: 'default',
	'&:hover': {
		backgroundColor: '#c00',
	},
}));

const AnniversaryCard = () => (
	<StyledContainer>
		<Typography variant="h6" component="div" gutterBottom>
			With over four decades of experience, <strong>Chakaravarthy Catering Center</strong> has
			been serving delicious and high-quality catering for all occasions. Our expertise,
			passion, and commitment to great taste make every event unforgettable!
		</Typography>
		<Box position={'relative'}>
			<Box
				sx={{
					position: { xs: 'relative', sm: 'relative', md: 'absolute', lg: 'absolute' },
					left: { xs: '0px', sm: '0px', md: '40%', xlg: '50%' },
					bottom: { xs: '0px', sm: '0px', md: '20%', lg: '10%' },
				}}
			>
				<StyledBadge
					src="/assets/anniversary.svg"
					alt="43rd Anniversary"
					sx={{ width: '270px', height: '270px', objectFit: 'cover' }}
				/>
			</Box>
			<Grid
				container
				spacing={2}
				justifyContent="center"
				sx={{ marginTop: { xs: '0px', sm: '0px', md: '100px' } }}
			>
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
					<Box
						sx={{
							width: '100%',
							display: 'flex',
							justifyContent: {
								xs: 'flex-start',
								sm: 'space-between',
								md: 'space-between',
							},
							flexDirection: { xs: 'column', sm: 'column', md: 'row' },
						}}
					>
						<StyledButton>100% No Compromise in Quality and Quantity</StyledButton>
						<StyledButton>Trusted By 1200 + Satisfied Clients</StyledButton>
					</Box>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
					<Box
						sx={{
							width: '100%',
							display: 'flex',
							justifyContent: {
								xs: 'flex-start',
								sm: 'space-evenly',
								md: 'space-evenly',
							},
							flexDirection: { xs: 'column', sm: 'column', md: 'row' },
						}}
					>
						<StyledButton>Full-Service for All Your Events</StyledButton>
						<StyledButton>Delicious Deals for Delicious Meals</StyledButton>
					</Box>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
					<Box
						sx={{
							// marginTop: { xs: '10px', sm: '10px', md: '25px' }
							display: 'flex',
							justifyContent: {
								xs: 'flex-start',
								sm: 'space-evenly',
								md: 'space-evenly',
							},
							flexDirection: { xs: 'column', sm: 'column', md: 'row' },
						}}
					>
						<StyledButton>Easy Customization Options</StyledButton>
					</Box>
				</Grid>
			</Grid>
		</Box>
	</StyledContainer>
);

export default AnniversaryCard;
